import posthog from 'posthog-js'

declare module 'posthog-js' {
  interface PostHog {
    isInitialized?: boolean
  }
}

export const initPostHog = (bootstrapFlags: any): void => {
  const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY
  const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST
  if (typeof window === 'undefined') return

  if (!posthog.isInitialized) {
    if (!posthogKey || !posthogHost) {
      // eslint-disable-next-line no-console
      console.log('PostHog: key or host not defined')
      return
    }

    posthog.init(posthogKey, {
      api_host: posthogHost,
      person_profiles: 'identified_only',
      disable_session_recording: true,
      disable_web_experiments: true,
      capture_pageview: false,
      autocapture: false,
      bootstrap: {
        featureFlags: bootstrapFlags || {}
      }
    })
    posthog.isInitialized = true
  }
}
